import React from 'react'
import PropTypes from 'prop-types'

import {
  Button,
  Dialog as MuiDialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  withMobileDialog,
} from '@material-ui/core'

const styles = {
  dialog: {
    overflow: 'visible',
  },
  paper: {
    overflow: 'visible',
  },
  content: {
    overflow: 'visible',
  },
}

const Dialog = ({
  closeLabel,
  title,
  children,
  fullScreen,
  isDialogOpen,
  handleClose,
  ...otherProps
}) => (
  <MuiDialog
    PaperProps={{ style: styles.paper }}
    style={styles.dialog}
    open={isDialogOpen}
    fullScreen={fullScreen}
    fullWidth={true}
    maxWidth={'md'}
    scroll={'body'}
    {...otherProps}
  >
    {
      title ?
        <DialogTitle>{title}</DialogTitle>
        :
        null
    }
    <DialogContent style={styles.content}>
      {children}
    </DialogContent>
    <DialogActions>
      <Button
        onClick={handleClose}
        variant={'text'}
      >
        {closeLabel}
      </Button>
    </DialogActions>
  </MuiDialog>
)

Dialog.defaultProps = {
  closeLabel: 'Close',
}

Dialog.propTypes = {
  closeLabel: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.node,
  fullScreen: PropTypes.bool.isRequired,
  isDialogOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
}

export default withMobileDialog()(Dialog)